// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"41295357","511":"d8536515","673":"fdefccb8","767":"32ec63db"}[chunkId] + ".chunk.js";
};